import { PsObject } from "./core/PsObject";

export default class SuccessFullyId extends PsObject<SuccessFullyId>{

    id: string = '';
    

    init(
        id: string,
        
    ) {
        this.id = id;
        
        return this;

    }

    getPrimaryKey(): string {
        return this.id;
    }


    fromMap(obj: any) {
        return new SuccessFullyId().init(
         obj.id,
        
        );
    }


    fromMapList(objList : any[] ) : SuccessFullyId[] {
        const SuccessFullyId : SuccessFullyId[] = [];
        for(const obj in objList) {
            if(obj != null) {
                SuccessFullyId.push(this.fromMap(obj));
            }
        }

        return SuccessFullyId;
    }


    toMap(object: SuccessFullyId): any {
        const map = {};
        map['id'] = object.id;
       
        return map;
    }

    toMapList(objectList: SuccessFullyId[]) : any[] {
        const mapList : any[] = [];
        for(let i = 0; i < objectList.length; i++) {
            if(objectList[i] != null) {
                mapList.push(this.toMap(objectList[i]));
            }
        }

        return mapList;
    }

    
}